import * as React from "react";
import { Outlet, useLocation } from "react-router-dom";
import SideMenu from "../../components/sidemenu/SideMenu";
import TopBar from "../../components/TopBar";
import { SidebarDrawer } from "../../components/common";
import SubscriptionAlert from "../../components/settings/Subscription/SubscriptionAlert";
import { ICustomer } from "../../@types";
import { useTour } from "../../context/TourContext";
import HiFive from "../../assets/icons/HiFive";
import TourGuideComponent, {
  tourGuideOptions,
} from "../../components/tourGide/SideBar";
import useRetailBusinessStatus from "../../hooks/invoice/useRetailBusinessStatus";
import { useUserStore } from "../../state";
import { useDashboardTourGuide } from "../../components/tourGide/useDashboardTourGuide";
import { useIsMobile } from "../../components/tourGide/useIsMobile";

interface DashboardLayoutProps {}

const DashboardLayout: React.FC<DashboardLayoutProps> = () => {
  const { pathname } = useLocation();

  const { registerSteps, startTour } = useTour();
  const { user } = useUserStore();
  const isMobile = useIsMobile();
  const {
    dashboardTourGuide,
    isCollapsed,
    setIsCollapsed,
    setShowMobileMenu,
    showMobileMenu,
  } = useDashboardTourGuide();
  registerSteps("home", [...dashboardTourGuide]);

  React.useEffect(() => {
    if (user?.firstLogin && !isMobile && user.businessName) {
      startTour("home");
    }
  }, [registerSteps]);

  const [isSidebarCollapsed, setIsSidebarCollapsed] = React.useState(true);
  const [showAlert, setShowAlert] = React.useState(false);
  const [isExpired, setIsExpired] = React.useState(false);
  const [selectedCustomer, setSelectedCustomer] =
    React.useState<ICustomer | null>(null);

  const handleSidebarToggle = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };
  const isRetailBusiness = useRetailBusinessStatus();
  let expired = false;
  let limitReached = false;

  if (expired) {
    setShowAlert(true);
    setIsExpired(true);
  }
  if (limitReached) {
    setShowAlert(true);
    setIsExpired(false);
  }

  return (
    <div id="#step-1" className="max-w-screen min-h-screen ">
      <div className="flex max-w-screen h-screen ">
        <SideMenu setIsCollapsed={setIsCollapsed} isCollapsed={isCollapsed} />
        <div
          className={`w-${isSidebarCollapsed ? "full" : "full"} ${
            pathname === "/dashboard" ? "bg-[#F2F4F7]" : "bg-[#ffffff]"
          } w-full border  overflow-x-hidden`}
        >
          <TopBar
            setShowMobileMenu={setShowMobileMenu}
            showMobileMenu={showMobileMenu}
            customer={selectedCustomer}
          />
          <div className="mt-[16px] md:mt-6 px-4 md:px-6 ">
            <Outlet />
          </div>
        </div>
      </div>

      <SidebarDrawer title="" position="left" show={showAlert}>
        <SubscriptionAlert isExpired={isExpired} />
      </SidebarDrawer>
    </div>
  );
};

export default DashboardLayout;
